import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
} from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-keyword-limit',
  templateUrl: './keyword-limit.component.html',
  styleUrls: ['./keyword-limit.component.css'],
})
export class KeywordLimitComponent {
  constructor(
    public dialogRef: MatDialogRef<KeywordLimitComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private router: Router,
    private translate: TranslateService
  ) {}

  upgradePlan() {
    this.dialogRef.close('upgrade');
    this.router.navigate(['/seo/billing']);
  }

  closeModal() {
    this.dialogRef.close('close');
  }

  getRemainingKeywords(): string {
    return this.data?.keywordsLeft || '0';
  }

  getProjectName(): string {
    return this.data?.projectName || 'your project';
  }
} 